import IAssessment from '../models/IAssessment';
import IAssessmentElement from '../models/IAssessmentElement';
import IAssessmentPage from '../models/IAssessmentPage';

export default class AssessmentHelpers
{
	public static getAllAssessmentQuestions(assessment: IAssessment) : IAssessmentElement[] 
	{
		let allAssessmentQuestions = [] as IAssessmentElement[]
		if (assessment)
		{
			for (let i = 0; i < assessment.pages.length; i++)
			{
				const page = assessment.pages[i];
				allAssessmentQuestions = allAssessmentQuestions.concat(this.getAllPageQuestions(page));
			}
		}
		return allAssessmentQuestions;
	}

	public static getAllPageQuestions(page: IAssessmentPage | null) : IAssessmentElement[] 
	{
		return (page?.headerSection ?? []).concat(page?.bodySection ?? []).concat(page?.footerSection ?? [])
	}
}
